import $detect from './detect'
import Storage from '@/utils/localstorage'
const Buffer = require('buffer/').Buffer
const _ = {}

_.getQuerys = (q, str) => {
  let val = {}
  let search = str || window.location.search || '?'
  search = search[0] === '?' ? search.substring(1) : search
  if (search) {
    search = search.split('&')
    search.forEach(function (kv) {
      val[kv.split('=')[0]] = kv.split('=')[1]
    })
  }
  return q ? (val[q] ? val[q] : '') : val
}

_.removeQuerys = (q, str) => {
  let val = []
  let search = str || window.location.search || '?'
  search = search[0] === '?' ? search.substring(1) : search
  if (search) {
    search = search.split('&')
    search.forEach(function (kv) {
      if (kv.split('=')[0] !== q) {
        val.push(kv);
      }
    })
  }
  val = val.join('&');
  return val === '?' ? '' : val;
}

_.paddingLeft = (val) => {
  const str = '' + val
  return str.length >= 2 ? str : '0' + str
}

_.compareVersion = (v1, v2) => {
  var _v1 = v1.split('.')
  var _v2 = v2.split('.')
  var _r = _v1[0] - _v2[0]
  return _r === 0 && v1 !== v2 ? _.compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.')) : _r
}

// 不支持情况的提配
_.getDisabledReminder = (store = {}) => {
  // 弹窗显示埋点
  if (store.dispatch) {
    store.dispatch('postBehaviors', {
      action: 'awd'
    })
  }
  // 点赞下载埋点
  const confirmBack = () => {
    if (store.dispatch) {
      store.dispatch('postBehaviors', {
        action: 'awdc'
      })
    }
  }
  // 移动端
  if (_.isMobile()) {
    // 非ios系统
    if (!$detect.os.ios) {
      return {
        message: '为获得最佳体验，请下载网易云游戏App（仅6M），新用户享免费畅玩和蓝光画质体验特权。',
        cancelBtn: '以后再说',
        confirmBtn: '马上下载',
        confirmBack: () => {
          confirmBack()
          window.open('https://adl.netease.com/d/g/enter/c/gw')
        }
      }
    }
    return {
      message: _.compareVersion($detect.os.version, '11') < 0 ? '请将ios系统升级到11以上并在Safari浏览器中游玩。' : '暂不支持在该浏览器游玩，请您使用Safari浏览器畅玩。',
      confirmBtn: '确定'
    }
  }
  // pc端
  return $detect.browser.ie ? {
    title: '暂不支持IE浏览器',
    message: '您可以使用Chrome、Firefox、360、QQ等浏览器体验。如尚未安装，推荐安装Chrome浏览器。',
    cancelBtn: '下载Chrome',
    confirmBtn: '我知道了',
    cancelBack: () => {
      confirmBack()
      window.open('https://www.google.cn/chrome/')
    }

  } : {
      title: '请将浏览器升级至最新版本',
      message: '您的浏览器版本过旧，暂不支持游玩，建议在浏览器设置中进行版本升级，或直接下载Chrome浏览器。~',
      cancelBtn: '下载Chrome',
      confirmBtn: '去更新',
      cancelBack: () => {
        confirmBack()
        window.open('https://www.google.cn/chrome/')
      }
    }
}

// 不支持的编码提示
_.getDisabledCodecs = () => {
  // 移动端
  if (_.isMobile()) {
    // 非ios系统
    if (!$detect.os.ios) {
      return {
        title: '浏览器不支持',
        message: '抱歉，您的浏览器暂不支持体验',
        confirmBtn: '下载APK',
        confirmBack: () => {
          window.open('https://adl.netease.com/d/g/enter/c/gw')
        }
      }
    }
    return {
      title: '浏览器不支持',
      message: '抱歉，当前浏览器不支持体验，您可以使用Safari打开游玩',
      confirmBtn: '用Safari打开游玩',
      confirmBack: () => {
      }
    }
  }
  return {
    title: '请将浏览器升级至最新版本',
      message: '您的浏览器版本过旧，暂不支持游玩，建议在浏览器设置中进行版本升级，或直接下载Chrome浏览器。~',
      cancelBtn: '下载Chrome',
      confirmBtn: '去更新',
      cancelBack: () => {
        window.open('https://www.google.cn/chrome/')
      }
  }
}

// 判断应用支持情况
_.canUse = () => {
  console.log('网络状态', $detect)
  // apk支持
  if (_.getDetect().os.neteaseCloud) {
    return true
  }

  // 移动端特殊版本不支持处理
  if (_.isMobile()) {
    // 微博
    if (_.isWeibo()) {
      // iOS都不支持
      if ($detect.os.ios) {
        return false
      }
      // android 7版本以下不支持
      if (_.compareVersion($detect.os.version, '7') < 0) {
        return false
      }
    }

    // uc浏览器
    if (_.isUC()) {
      // iOS都不支持
      if ($detect.os.ios) {
        return false
      }
    }
  }
  // 支持webrtc 即可用使用
  if (_.isSuperWebRtc()) {
    return true
  }
  // const limit = (+process.env.VUE_APP_LIMIT_PC)
  // console.log('can Use limitPc', limit)
  // if (!limit) {
  //   return true
  // }

  // // 移动端 且是我们apk平台 或者ios的safari 或者微信或者QQ
  // if (_.isMobile() && (_.getDetect().os.neteaseCloud || (($detect.browser.safari || _.isWeiXin() || _.isQQ()) && _.isSuperWebRtc()))) {
  //   return true
  // }

  // //  pc必须chrome 且版本69
  // if (!_.isMobile() && $detect.browser.chrome &&
  //   _.compareVersion($detect.browser.version, '69') >= 0) {
  //   return true
  // }
  return false
}
_.isMobile = () => {
  return $detect.os.phone || $detect.os.tablet
}

// 支持webRtc
_.isSuperWebRtc = () => {
  // 检测RTC
  const checkRTCPeerConnection = () => {
    let RTCPeerConnectionSupport = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    let bool = false
    try {
      // 避免第三方浏览器并无具体功能
      if (RTCPeerConnectionSupport) {
        let pc = new RTCPeerConnectionSupport(null)
        pc.close()
        pc = null
        bool = true
      }
    } catch (e) {
      bool = false
    }
    return bool
  }
  // 检测media
  // const checkMeida = () => {
  //   let getUserMediaSupport = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.mediaDevices && navigator.mediaDevices.getUserMedia
  //   return !!getUserMediaSupport
  // }
  // 检测websocket
  const checkSocket = () => {
    return !!window.WebSocket
  }
  // console.log('checkMeida', checkMeida())
  console.log('checkRTCPeerConnection', checkRTCPeerConnection())
  console.log('checkSocket', checkSocket())
  return /*checkMeida() &&*/ checkRTCPeerConnection() && checkSocket()
}

// 支持Flv
_.isSuperFlv = () => {
  // 检测websocket
  const checkSocket = () => {
    return !!window.WebSocket
  }
  // 检测支持MSE
  const checkMSE = () => {
    return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"')
  }
  return checkSocket() && checkMSE()
}

// 获取media
_.getVideoMedia = () => {
  // 支持webrtc
  if (_.isSuperWebRtc()) {
    return 'webrtc'
  }

  // 支持flv
  if (_.isSuperFlv()) {
    return 'websocket'
  }
}

_.getDetect = () => {
  return $detect
}

_.isWeiXin = () => {
  return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
}
_.isQQbrw = () => {
  return navigator.userAgent.toLowerCase().indexOf('qqbrowser') !== -1 // QQ浏览器
}
_.isQQ = () => {
  return navigator.userAgent.toLowerCase().match(/qq/i) == 'qq' && !_.isQQbrw() && !_.isWeiXin()
}
_.isWeibo = () => {
  return navigator.userAgent.toLowerCase().match(/weibo/i) == "weibo"
}
_.isUC = () => {
  return navigator.userAgent.toLowerCase().match(/ucbrowser/i) == "ucbrowser"
}
_.isAweme = () => {
  return navigator.userAgent.toLowerCase().match(/aweme/i) == "aweme"
}
_.isNewsArticle = () => {
  return navigator.userAgent.toLowerCase().match(/newsarticle/i) == "newsarticle"
}
_.inSet = () => {
  // tv平台
  if ($detect.os.tv) {
    document.body.classList.add('InTV')
  // 移动端
  } else  if (_.isMobile()) {
    document.body.classList.add('InMobile')
    // 如果是mumu，需要变化一下字体大小
    if (($detect.os.channel || '').toLowerCase() === 'mumu') {
      document.body.classList.add('InMuMu')
    }
  }
}

// 打开方式
_.open = (url, params = {}) => {
  console.log('要来开启游戏了？？？url', url, params)

  if (url.indexOf('run.html') > -1) {
    url = url + '&id=' + (+new Date())
    const options = params.params || {}
    const href = window.location.href
    const layout = params.layout
    const isNeteaseCloud = $detect.os.neteaseCloud

    if ((href.indexOf('.html') > 0) && (href.indexOf('index.html') === -1)) {
      url = url + '&other=1'
    }
    // 自开启
    if (href.indexOf('gamestart.html') > 0) {
      url = url + '&autostart=1&callback=' + encodeURIComponent(href)
    }
    // 获取layout 判断是竖屏，则添加
    if (layout === 'vertical') {
      url = url + '&layout=port'

      // 云平台强制竖屏打开
      if (isNeteaseCloud) {
        window.NCGJsBridge.page(window.location.origin + '/' + url, 'port')
        return true
      }
    }
    // 如果是云电脑，则不需要确认框，当前页面进入
    if (options.game_code === 'cloud_pc') {
      url = url + '&inline=1&callback=' + encodeURIComponent(href)
      params.inline = true;
    }
    // pc游戏且是云游戏平台
    if (options.game_type === 'pc' && isNeteaseCloud) {
      let pageParams = {}
      let encrypt = Storage.get('NCG-eid-other') || Storage.get('NCG-eid')
      let EID = _.cookieGet(encrypt)
      let OFFSET = _.getOffset2(EID)
      let width = 1920
      let height = 1080
      // let playingParams = options.params || {}
      // let lock_detail = options.lock_detail || {
      //   width: 1920,
      //   height: 1080
      // }
      // 换端玩
      // if (playingParams.width && playingParams.height) {
      //   width = playingParams.width
      //   height = playingParams.height
      // } else {
      //   let screen = _.getVideoScreen(false, lock_detail.width, lock_detail.height)
      //   width = screen.w
      //   height = screen.h
      // }
      pageParams = {
        gamecode: options.game_code,
        gateway: options.gateway_url,
        uid: options.user_id,
        token: Storage.get('NCG-token-other') || Storage.get('NCG-token'),
        eid: OFFSET,
        quality: Storage.get('NCG-pc-quality') || 'high',
        width: width,
        height: height,
        region: options.region,
        region_name: options.region_name,
        platform: _.getXPlatform(),
        free: options.free
      }
      window.NCGJsBridge.page(window.location.origin + '/' + url, 'pc', pageParams)
      return true
    }
  }

  const sourceType = _.getQuerys('sourcetype');

  if (sourceType) {
    const str = (url.indexOf('?') === -1 ? '?' : '&') + 'sourcetype=' + sourceType

    if (url.indexOf('#') !== -1) {
      const [p, n] = url.split('#');
      url = p + str + '#' + n;
    } else {
      url = url + str
    }
  }

  const projectId = _.getQuerys('project_id');

  if (projectId) {
    const str = (url.indexOf('?') === -1 ? '?' : '&') + 'project_id=' + projectId

    if (url.indexOf('#') !== -1) {
      const [p, n] = url.split('#');
      url = p + str + '#' + n;
    } else {
      url = url + str
    }
  }

  // electron
  if ($detect.os.electron) {
    _.locReplace(url)
    return true
  }

  // 活动页
  if (params.startType === 'inline') {
    _.locReplace(url + '&autostartinline=1')
    return true
  }

  // 微信，是直接替换
  if (_.isWeiXin() || _.isMobile()) {
    _.locReplace(url)
    return true
  }
  // 移动端
  if (_.isMobile()){
    // 确定是跳转到运行页
    if (url.indexOf('run.html') > -1) {
      _.lockPortrait()
    }
    // window.location.href = url
    _.locReplace(url)
    return true

  // pc端云电脑当前页打开
  } else if (params.inline) {
    _.locReplace(url)
    return true
  }
  // 开启的页面若为运行页的改为''
  if (window.name === 'runningWindow') {
    window.name = ''
  }
  // electron处理
  if ($detect.os.electron) {
    window.open(url, 'runningWindow')
    return true
  }
  let openNewWindow = window.open('', 'runningWindow')
  if (openNewWindow && openNewWindow.location) {
    openNewWindow.location.href = url
  }
  return openNewWindow
}
_.locReplace = (url) => {
  window.location.replace(url)
}

// 转横屏
_.lockPortrait = (bool) => {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.lock && window.webkit.messageHandlers.lock.postMessage) {
    const type = bool ? 'Portrait' : 'Landscape'
    window.webkit.messageHandlers.lock.postMessage(type)
  }
}

/* 获取平台类型
  WEB PC => 0
  WEB 移动端 => 1
  iOS移动端平台 => 4
  Android移动端平台 => 2
  Android移动端单APK => 3
  Android TV 单APK => 5
  Android TV 平台 => 6
*/
_.getXPlatform = () => {
  const os = $detect.os || {}
  // 原生应用
  if (os.neteaseCloud) {
    if (os.pc) {
      return 8
    } 
    if (os.iosAPP) {
      return 9
    } 
    if (os.tv) {
      if (os.single) {
        return 5
      }
      return 6
    }
    if (os.single) {
      return 3
    }
    return 2
  // 移动端
  } else if (_.isMobile()) {
    // ios移动端
    if (os.ios) {
      return 4
    }
    return 1
  }
  return 0
}

// 获取平台信息
_.getXChannel = () => {
  const os = $detect.os || {}
  return os.channel
}
// 随机
_.randomSplit = (str) => {
  return str.split(',').map(function (item) { return item.split(':')[1]}).join('d')
}

// 随机字符
_.randomString = () => {
  return Math.random().toString(36).substring(2).substring(0, 2)
}

/*cookie的写入方法，把encrypt信息转变为数字信息*/
_.cookieSet = (str) => {
  const arr = str.split('')
  const cuurent = arr.map(function(elem) {
    return elem.charCodeAt() + '-' + _.randomString()
  })
  return cuurent.join('-')
}

/*cookie的获取*/
_.cookieGet = (str) => {
  const arr = str ? str.split('-') : []
  return String.fromCharCode.apply(null, arr.filter((item, index) => {return index%2 == 0}))
}

/*获取偏移量*/
_.getOffset2 = (str) => {
  const formate = str.split('d').map((item) => { return +item})
  return _.getOffset.apply(null, formate.slice(1))
}
/*获取偏移量*/
_.getOffset = (number, timestamp, salt) => {
  return ((number | timestamp) % 256) + salt
}
_.offsetEn = (offset, data) => {
  const buffer = Buffer.from(data)
  for (var i = 0; i < buffer.length; i++) {
    buffer[i] = (buffer[i] + offset) % 256
  }
  return buffer.toString('base64')
}
_.offsetOut = (offset, data) => {
  const buffer = Buffer.from(data, 'base64')
  for (var i = 0; i < buffer.length; i++) {
    buffer[i] = (buffer[i] - offset) % 256
  }
  return buffer.toString()
}
/*获取基数*/
_.gcd = (a, b) => {
  return (b == 0) ? a : _.gcd (b, a%b)
}

/*获取当前的分辨率*/
_.getRatio = (width, height) => {
  const cardinal = _.gcd(width, height)
  return [width/cardinal, height/cardinal].join(':')
}
/*获取当前的分辨率*/
_.getKeyMapping = (gameConfig, videoWidth, videoHeight) => {
  let target = {}
  let min = null
  let max = null
  let ratio = null
  const games = {}
  gameConfig.map((item) => {
    const key = item.ratio
    if (!ratio) {
      const numbers = key.split(':')
      const x = numbers[0] * videoHeight
      const y = numbers[1] * videoWidth
      if (x === y) {
        ratio = key
      } else if (x > y) {
        if (!max) {
          max = numbers
        } else if (numbers[0] * max[1] < numbers[1] * max[0]) {
          max = numbers
        }
      } else {
        if (!min) {
          min = numbers
        } else if (numbers[0] * min[1] > numbers[1] * min[0]) {
          min = numbers
        }

      }
    }
    if (!games[key]) {
      games[key] = []
    }
    games[key].push(item)
  })

  // 若无匹配，取中间值
  if (!ratio) {
    if (min && !max) {
      ratio = min.join(':')
    } else if (max && !min) {
      ratio = max.join(':')
    } else if (videoWidth * 2 < videoHeight * (min[0]/min[1] + max[0]/max[1])) {
      ratio = min.join(':')
    } else {
      ratio = max.join(':')
    }
  }

  // 取具体的keymapping
  games[ratio].map((item) => {
    if ((target.create_time || 0) <= (item.create_time || 0)) {
      target = item
    }
  })
  return target
}

// 动态注入js
_.insertJs = (url) => {
  return new Promise((resolve, reject) => {
    const tag = document.createElement('script')
    tag.type = 'text/javascript'
    tag.src = url
    const s = document.getElementsByTagName('head')[0]
    s.appendChild(tag)
    tag.addEventListener('load', resolve)
    tag.addEventListener('error', reject)
  })
}

// 获取当前的可播放区域
_.getVideoScreen = (w, h, port, active) => {
  let videoHeight = h || 720
  let videoWidth = w || 1280
  if (_.isMobile() || active) {
    const ios = $detect.os.ios && !(_.isWeiXin() || _.isQQ() || _.isAweme() || _.isNewsArticle())
    // 主屏
    const isStand = window.navigator.standalone
    // ios 流海屏
    const iponeX = ios && _.isIphoneX()
    let innerWidth
    let innerHeight
    let screen
    let width
    let height

    // ios横屏游戏 or 主屏按全屏显示 且非活动
    if (((ios && !port) || isStand) && !active) {
      screen = window.screen
      innerWidth = Math.ceil(screen.width)
      innerHeight = Math.ceil(screen.height)
    // 按当前可显示区域
    } else {
      innerWidth = Math.ceil(window.innerWidth)
      innerHeight = Math.ceil(window.innerHeight)
    }
    // 竖屏游戏
    if (port) {
      width = Math.max(innerWidth, innerHeight) - (isStand ? (iponeX ? 44 : 20) : 0)
      height = Math.min(innerWidth, innerHeight)
    // 横屏游戏
    } else {
      width = Math.max(innerWidth, innerHeight) - (iponeX ? 44 : 0)
      height = Math.min(innerWidth, innerHeight) - (isStand ? 20 : 0)
    }
    videoWidth = Math.floor(width * videoHeight / height)
  }
  return {
    w: videoWidth,
    h: videoHeight
  }
}

// 是否当前分辨率 设备分辨率相差超过5%时
_.isClosetoRatio = (w, h, ratio) => {
  const lR = w/h
  let nR = ratio
  console.log('是否已有分辨率了', ratio)
  if (!ratio) {
    const screen =_.getVideoScreen()
    nR = screen.w/screen.h
  }
  console.log('现在分辨率2222', nR, '之前的分辨率', lR, lR * 0.95, lR * 1.05)
  return nR >= lR * 0.95 && nR <= lR * 1.05
}

// 判断iphone是否有浏览
_.isIphoneX = () => {
  if (!$detect.os.ios) {
    return false
  }
  console.log('是ios')
  const ratio = window.devicePixelRatio || 1
  const winScreen = window.screen
  const w = winScreen.width * ratio
  const h = winScreen.height * ratio
  const screen = {
    width: Math.min(w, h),
    height: Math.max(w, h)
  }
  console.log(screen, ratio)
  const isX = screen.width === 1125 && screen.height === 2436
  const isXSMAX = screen.width === 1242 && screen.height === 2688
  const isXR = (screen.width === 750 && screen.height === 1624) || (screen.width === 828 && screen.height === 1792)

  // 那么判断是否是刘海屏
  return isX || isXSMAX || isXR
}

// 判断先区是否修改
_.isChangeRegions = (now = [], old = []) => {
  console.log('isChangeRegions', now, old)
  // 长度不一致
  if (now.length !== old.length) {
    return true
  }
  function getReionString (arr = []) {
    return arr.map((elem) => {
      return elem.region
    }).sort().join('|')
  }
  return getReionString(now) !== getReionString(old)
}

// 判断是否区当前平台
_.isInPlatform = (platforms = []) => {
  const cuurentPaltform = _.getXPlatform()
  return platforms.some((item) => {
    return item == cuurentPaltform
  })
}

// 判断是否当前渠道
_.isInChannel = (channels = []) => {
  const cuurentChannel = _.getXChannel()
  return channels.length ? channels.some((item) => {
    return item == cuurentChannel
  }) : true
}

// 判断是否华数
_.isHS = (channel) => {
  return channel && channel.toLocaleLowerCase() === 'wasudesktop'
}
// 获取返回
_.getCallback = () => {
  return decodeURIComponent(_.getQuerys('callback') || '') || 'index.html'
}

// 浏览器版本
_.borowserVerionsLeft = (browser, version) => {
  const cuurentBrouser = $detect.browser || {}
  const cuurentVersion = cuurentBrouser.version
  return cuurentBrouser[browser] && cuurentVersion && _.compareVersion(cuurentVersion, version) < 0
}
// os版本
_.osVerionsLeft = (os, version) => {
  const cuurentOs = $detect.os || {}
  const cuurentVersion = cuurentOs.version
  return cuurentOs[os] && cuurentVersion && _.compareVersion(cuurentVersion, version) < 0
}


// 小米系统
_.isMiui = () => {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('xiaomi') > -1 || ua.indexOf('miuibrowser') > -1) {
    return true
  }
  return false
}

// 获取编码
_.getStaticCodec = () => {
  let codecs
  // 小米系统 强制vp8
  if (_.isMiui ()) {
    return ['vp8']
  }
  try {
    codecs = RTCRtpReceiver.getCapabilities('video').codecs
  } catch(e) {
    codecs = []
  }
  return codecs.map((item) => {
    const key = (item.mimeType || item.name).toLowerCase()
    return key.replace('video/', '')
  })
}

_.getDynamicCodec = (back) => {
  try {
    let RTCPeerConnectionSupport = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    let pc = new RTCPeerConnectionSupport(null)
    let offer_sdp = `v=0
o=- 0 0 IN IP4 0.0.0.0
s=-
t=0 0
a=group:BUNDLE video
a=msid-semantic:WMS media-stream
m=video 60235 UDP/TLS/RTP/SAVPF 96 98 99 100
c=IN IP4 0.0.0.0
a=rtcp:9 IN IP4 0.0.0.0
a=ice-ufrag:043f20ec
a=ice-pwd:6dadc3885ca687024e1fa31f
a=fingerprint:sha-256 2C:D2:16:BB:17:1A:1D:F8:12:BA:39:1A:3F:C5:5C:15:47:7B:57:43:08:0D:16:21:6A:35:45:B9:A7:74:66:79
a=setup:actpass
a=mid:video
a=sendonly
a=rtcp-mux
a=rtpmap:96 H264/90000
a=fmtp:96 packetization-mode=1;level-asymmetry-allowed=1;profile-level-id=42e01f
a=rtpmap:98 VP8/90000
a=rtpmap:99 VP9/90000
`;

    pc.setRemoteDescription({'type':'offer', 'sdp':offer_sdp}).then(() => pc.createAnswer()).then(answer => {
      const sdp = answer.sdp
      const rtpmaps = sdp.match(/a=rtpmap:\d+\s*(\w*)\/\d+/g)
      const codecs = rtpmaps.map((item) => {
        return item.replace(/a=rtpmap:\d+\s*/, '').replace(/\/\d+/, '').toLowerCase()
      })
      console.log('当前的codecs', codecs)
      back && back(codecs)
      pc && pc.close()
    }).catch((err)=> {
      console.log('getDynamicCodec err', err)
      back && back(['vp8'])
    })

  } catch (e) {
    back && back(['vp8'])
  }
}

// ios 14及以下版本不支持 h265，过波掉
_.pickOutH265 = (codecs = []) => {
  const cuurentOs = $detect.os || {}
   const cuurentVersion = cuurentOs.version
  // 非ios 不处理
  if (!cuurentOs.ios) {
    return codecs
  }
  // ios 小于14
  if (_.compareVersion(cuurentVersion, '14') < 0) {
    return codecs
  }
  // 大于等于14版本，都要过滤掉h265
  return codecs.filter((code) => {
    return code.toLowerCase() !== 'h265'
  })
}

// 获取编码
_.getVideoCodecs = () => {
  return new Promise((resolve) => {
    const codecs = _.getStaticCodec()
    if (codecs.length) {
      resolve({
        codecs: _.pickOutH265(codecs)
      })
      return
    }
    _.getDynamicCodec((codecs) => {
      resolve({
        codecs: codecs
      })
    })
  })

}

// 获取encoder
_.getEncoder = (codecs = [], gameType) => {
  if (codecs && codecs.length === 1 && codecs[0] === 'vp8') {
    return 'vp8'
  }
  // 非端游、chrome 小于59 强制 cpu
  if (gameType && gameType !='pc') {
    // ios小于12
    if (_.osVerionsLeft('ios', '12')) {
      return 'x264'
    }
    // chrome 小于59
    if (_.borowserVerionsLeft('chrome', '59') && _.hasH264(codecs)) {
      return 'x264'
    }
  }
  return ''
}

// 有vp8
_.hasVp8 = (codecs = []) => {
  return codecs.some((item) => {
    return item.toLowerCase() === 'vp8'
  })
}
// 有h264
_.hasH264 = (codecs = []) => {
  return codecs.some((item) => {
    return item.toLowerCase() === 'h264'
  })
}

// location.search to object
_.searchToObject = () => {
  const pairs = window.location.search.substring(1).split("&")
  let obj = {}, pair, i;

  for ( i in pairs ) {
    if ( pairs[i] === "" ) continue
    pair = pairs[i].split("=")
    obj[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] )
  }
  return obj
}
_.getUniqueId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default _